module.exports = __webpack_public_path__ + "img/buddy_nose-02.1a12f998.svg";